// Vendors
import * as PIXI from 'pixi.js'

export class MapElement extends PIXI.Container {

    public level: number;
    public isRevard: boolean;
    public isGetRevard: boolean;

    constructor() {
        super();
    }
}